import Home from '../components/home.vue';//首页
import productionShow from '../components/productionShow.vue';//产品展示
import community from '../components/hardware.vue';//盲人社区
import News from '../components/News.vue';//新闻动态
import contactUs from '../components/contactUs.vue';//联系我们
import newsDetail from '../components/newsDetail.vue';//新闻详情
import communityDetail from '../components/communityDetail.vue';
import productDetails from "../components/productDetails";
//盲人社区详情

export default {
  routes:[
    {
      path:"/",
      components:{
        default:Home
      }
    },
    {
      path:'/home',
      component:Home
    },
    {
      path:'/news',
      component:News
    },
    {
      path:'/productionShow',
      component:productionShow
    },
    {
      path:'/community',
      component:community
    },
    {
      path:'/contactUs',
      component:contactUs
    },
    {
      path:'/newsDetail',
      component:newsDetail
    },
    {
      path:'/communityDetail',
      component:communityDetail
    },
    {
      path: '/productDetails',
      component: productDetails
    }
  ]
}




// WEBPACK FOOTER //
// ./src/router/index.js